import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { levelsQuery } from '~/util/queries/public/levels';
import { useRouletteStore } from '~/util/stores/roulette';
import { RouletteHome } from './-Home';
import { RouletteRound } from './-Round';
import { seo } from '~/util';
import { PlacedLevel } from '~/util/types/levels';

export const Route = createFileRoute('/games/roulette')({
    loader: async ({ context: { queryClient } }) => {
        return (await queryClient.fetchQuery(
            levelsQuery({
                list: 'classic',
                exclude_pending: true,
                exclude_removed: true,
            }),
        )) as PlacedLevel[];
    },
    head: () => ({
        meta: seo({
            title: 'Extreme Demon Roulette',
        }),
    }),
    component: RouletteLayout,
});

function RouletteLayout() {
    const {
        data: {
            currentGameState: { level },
        },
        migrateFromOldData,
    } = useRouletteStore();

    // Migrate old localStorage data to new format on mount
    useEffect(() => {
        migrateFromOldData();
    }, [migrateFromOldData]);

    return level == undefined ? <RouletteHome /> : <RouletteRound />;
}
